import { IGroupChatData } from "@home-health-notify/domain";
import { List } from "@mui/material";
import { useTranslation } from "hhn-commons";
import EmptyRecordView from "../../../common/EmptyRecordView";
import GoToTop from "../../../common/GoToTop";
import ScrollListContainer from "../../../common/ScrollListContainer";
import { useScrollAnchor } from "../../../hooks/useScrollAnchor";
import ProgressLoader from "../../../loader/ProgressLoader";
import InternalGroupChatListItem from "./InternalGroupChatListItem";

type InternalGroupChatListProps = {
  chats: IGroupChatData[];
  selectedChatId?: string;
  isChatLoading: boolean;
  fetchChatList: () => Promise<void>;
  isMoreChats: boolean;
};

const InternalGroupChatList = ({
  chats,
  selectedChatId,
  isChatLoading,
  fetchChatList,
  isMoreChats,
}: InternalGroupChatListProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  const { scrollContainerRef, isShowGoToTopButton, goToTop } = useScrollAnchor({
    items: chats,
    getItemId: chat => chat.id,
    getItemVersion: chat => chat.updatedAt,
    selectedItemId: selectedChatId,
  });

  return (
    <>
      <ScrollListContainer
        ref={scrollContainerRef}
        onScrollCallback={fetchChatList}
        isLoading={isChatLoading}
        dataTestId="nonPatientChatList"
        restTop={isChatLoading ? 176 : 154}
      >
        <>
          {isShowGoToTopButton && <GoToTop onClick={goToTop} />}
          {chats.length > 0 && (
            <List data-testid="chatList" sx={{ paddingTop: "0px" }}>
              {chats.map((chatData: IGroupChatData) => (
                <InternalGroupChatListItem
                  key={chatData.id}
                  chatData={chatData}
                  isSelected={selectedChatId === chatData.id}
                />
              ))}
            </List>
          )}
          {!isChatLoading && !isMoreChats && chats.length !== 0 && (
            <EmptyRecordView emptyMessage={t("endOfTheListMessage")} />
          )}
          {!isChatLoading && chats.length === 0 && <EmptyRecordView />}
          {isChatLoading && (
            <ProgressLoader
              label={tNs("chatLoadingMessage")}
              style={{
                height: "auto",
              }}
            />
          )}
        </>
      </ScrollListContainer>
    </>
  );
};

export default InternalGroupChatList;
